// extracted by mini-css-extract-plugin
export default {"wrapper":"Time_wrapper__wal9B"};